import { Component, Input, Output, OnInit, EventEmitter, ElementRef, ViewChild, Renderer2, forwardRef, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { ChangeDetectorRef } from '@angular/core';
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule, FormGroup } from "@angular/forms";
import { IItemConfig, CategoryItemConfig, DateItemConfig, HtmlItemConfig, DropdownItemConfig, ItemConfigTypes, ItemConfigBase } from "../../../interfaces/iitemconfig";
import { Router, RouterModule } from "@angular/router";
import { ItemConfigService } from "../../../services/itemconfig.service";
import { ToastrService } from "ngx-toastr";
import { ItemConfigHierachyService } from "../../../services/itemconfighierachy.service";
import { DropDownItem } from "../../../models/dropdown";
import { Store } from "@ngrx/store";
import { IAppStore } from "../../../iappstore";
import { NgSelectComponent } from "../../shared/ng-select/ng-select.component";
import { CountdownPipe } from "../../../pipes/countdown.pipe";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { CdkDragDrop, moveItemInArray, DragDropModule } from "@angular/cdk/drag-drop";

@Component({
    selector: "itemconfiglistitem",
    templateUrl: "./itemconfiglistitem.component.html",
    styleUrls: ["./itemconfiglistitem.component.css"],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, NgSelectComponent, CountdownPipe, forwardRef(() => ItemConfigListItemComponent), TooltipModule, DragDropModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class ItemConfigListItemComponent implements OnInit {
    @Input() item: ItemConfigBase;
    @Input() items: ItemConfigBase[];
    @Input() dropdownOptions: DropDownItem[];
    @Input() formGroup: FormGroup;
    @Input() depth: number;
    @Input() hideDisableItems: boolean;
    @Output() itemDeleted: EventEmitter<any> = new EventEmitter();
    public itemConfigType = ItemConfigTypes;
    selectedDropdownItem: DropDownItem;
    @ViewChild("menu") menu: ElementRef;
    documentClickListener: Function | null = null;

    showMenu = false;
    showChildren = false;
    maxlength = 500;

    constructor(
        private router: Router,
        private eref: ElementRef,
        private toastr: ToastrService,
        private itemConfigService: ItemConfigService,
        private renderer: Renderer2,
        private itemConfigHierachyService: ItemConfigHierachyService,
        private store: Store<IAppStore>,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.initialiseForm();
    }

    initialiseForm(): void {
        switch (this.item.itemConfigType) {
            case ItemConfigTypes.DropdownItemConfig:
                this.selectedDropdownItem = this.dropdownOptions.find((i: DropDownItem) => {
                    return i.id === (this.item as DropdownItemConfig).dropdownId;
                });
                if (!this.selectedDropdownItem) {
                    this.selectedDropdownItem = <DropDownItem>{ id: null, text: "Please select a dropdown" };
                }
                break;
            default:
            // no custom properties on other config types to set
        }
    }

    /**
     * destroy event for compnent
     */
    ngOnDestroy(): void {
        // execute  function to remove the listener
        if (this.documentClickListener) {
            this.documentClickListener();
        }
    }

     toggleMenu(): void {
        // use mousedown as click wont work with the drag
        this.documentClickListener = this.renderer.listen("document", "mousedown", (event: any) => {
            if (this.menu && !this.menu.nativeElement.contains(event.target)) {
                this.showMenu = false;
                this.cdr.detectChanges();
                this.documentClickListener(); // remove it once we are done
            }
        });

        this.showMenu = !this.showMenu;
    }

    onDropDownItemSelected(dropdownItem: DropDownItem): void {
        debugger;
        this.selectedDropdownItem = dropdownItem;
        (this.item as DropdownItemConfig).dropdownId = this.selectedDropdownItem.id;
        this.saveItem();
    }

    onClick(event: any): void {
        if (!this.eref.nativeElement.contains(event.target)) { // or some similar check
            this.showMenu = false;
        }
    }

    toggleChildren(): void {
        this.showChildren = !this.showChildren;
    }

    validateForm(): string[] {
        let errors: string[] = new Array();
        if (!this.item.name) {
            errors.push("Please provide a name");
        }

        switch (this.item.itemConfigType) {
            case ItemConfigTypes.DropdownItemConfig:
                if (!this.selectedDropdownItem.id) {
                    errors.push("Please provide a dropdown");
                }
                break;
        }
        return errors;

    }

    saveItem(): void {
        let errors: string[] = this.validateForm();
        if (errors.length > 0) {
            errors.forEach((i: string) => {
                this.toastr.error(i);
            });
        } else {
            this.itemConfigService.save(this.item).subscribe(
                i => {
                    this.item.id = i.id;
                    this.toastr.success("Changes have been successfully saved");
                },
                () => {
                    this.item.name = "";
                    this.toastr.error("Your changes have not been saved");
                }
            );
        }
    }

    addItem(type: ItemConfigTypes): void {
        // used for creating items
        this.showChildren = true;

        if (this.items.find((i: IItemConfig) => { return i.name.trim().length === 0; })) {
            this.toastr.warning("Please complete the empty item before adding more sibling/child items.");
            this.showMenu = false;
        } else {
            // add item based on type todo: this should be refactored into seperate components
            this.addNewItemConfigToItems(type);
        }
    }

    addNewItemConfigToItems(type: ItemConfigTypes): void {
        switch (type) {
            case ItemConfigTypes.CategoryItemConfig:
                this.items.unshift(new CategoryItemConfig(
                    "",
                    this.item.id,
                    false));
                break;
            case ItemConfigTypes.DateItemConfig:
                this.items.unshift(new DateItemConfig(
                    "",
                    this.item.id,
                    false));
                break;
            case ItemConfigTypes.HtmlTextItemConfig:
                this.items.unshift(new HtmlItemConfig(
                    "",
                    this.item.id,
                    false));
                break;
            case ItemConfigTypes.DropdownItemConfig:
                this.items.unshift(new DropdownItemConfig(
                    "",
                    this.item.id,
                    false));
                break;
        }
    }

    toggleDisableItem(): void {
        // used for disabling/reenabling items
        if (!this.item.id) {
            this.deleteItem();
        } else {
            this.item.disabled = !this.item.disabled;
            this.itemConfigService.save(this.item).subscribe(
                () => {
                    this.toastr.success("Changes have been successfully saved");
                },
                () => {
                    this.toastr.error("Your changes have not been saved");
                }
            );
        }
    }

    reorderAndSave(): void {
        const updatedItems: IItemConfig[] = this.itemConfigHierachyService.updateItemsSortOrder(this.item.children, this.item.id, false);
        if (updatedItems.length > 0) {
            this.itemConfigService.updateItems(updatedItems).subscribe(() => {
                this.toastr.success("Changes have been successfully saved");
            });
        }
    }

    /**
     * Handles drag and drop events for child items
     * @param event The CDK drop event
     */
    onChildDrop(event: CdkDragDrop<IItemConfig[]>): void {
        if (event.previousIndex !== event.currentIndex) {
            moveItemInArray(this.item.children, event.previousIndex, event.currentIndex);
            this.reorderAndSave();
        }
    }

    deleteItem(): void {
        this.itemDeleted.emit();
    }

    onItemDeleted(item: IItemConfig): void {
        this.item.children = this.item.children.filter(itm => itm !== item);
    }
}





